import { css } from "@emotion/react";
import { themes } from "../../styles/theme";

export const primaryTextColor = css`
  color: ${themes.dark.font.primary.default};
`;
